<div class="p-3 position-fixed bottom-0 end-0 z-3">
  <button [class.visible]="isVisible"
          class="p-0 btn btn-nz-primary rounded-circle scroll-top-button"
          (click)="scrollToTop()">
    <i class="fa-solid fa-chevron-up"></i>
  </button>
</div>
